import React, {Component} from "react"
import PropTypes from "prop-types"
import {InjectedIntl} from "react-intl"
import {get} from "lodash"

import {injectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {Poll, Recognition} from "@irati/types"
import History from "@irati/utils/history"
import {IconTypes} from "@irati/ui/src/Icon"
import {officeForUser} from "@irati/identity/utils/tenant/hasMultipleOffices"

import IconWithNumber from "./IconWithNumber"
import Tooltip, {Tip} from "../shared/Tooltip"

interface Props extends InjectedIntl{
  type: string,
  item: Poll | Recognition
}

interface State {
  userIsInBU: boolean
}

class AddRewardIcon extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    userIsInBU: false
  }

  componentDidMount() {
    officeForUser().then((office) => {
      // if the user is in a BU, hide "add reward" until re-write
      this.setState({userIsInBU: !!office})
    })
  }

  handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    const {item, type} = this.props
    const canReward = authentication.apps("recognition.rewards.create")
    if (item.reward || !canReward) {
      return null
    }
    History.push({pathname: "/reward/add", state: {item, type}}, this.context)
  }

  getRewardText = () => {
    const {item, formatMessage} = this.props
    const isRewardLimited = authentication.apps("recognition.rewards.viewLimited")

    if (item.rewardOrder) {
      let user = get(item.rewardOrder, "createdBy")
      if (!user) {
        // don't know why it shouldn't be a user there, but we don't want to display fake infos
        user = {
          firstname: "",
          lastname: ""
        }
      }
      const name = firstnameLastname(user)
      if (isRewardLimited) {
        return formatMessage({id: "recognition.addReward.tooltip.partialView"}, {name})
      }
      return formatMessage({id: "recognition.addReward.tooltip.fullView"}, {reward: get(item.rewardOrder, "reward.header") || "", name})
    }
    return formatMessage({id: "recognition.addReward.tooltip.default"})
  }

  render() {
    const {item} = this.props
    const {userIsInBU} = this.state
    const isRewardDisabled = !!authentication.apps("recognition.recognition.rewardDisabled")
    const canReward = authentication.apps("recognition.rewards.create")

    if (userIsInBU || isRewardDisabled || (!item.reward && !canReward)) return null
    const rewardActive = item.reward && (item?.createdBy?.uuid === authentication.user().uuid)

    return (
      <Tooltip id="addRewardTip" placement="bottom" tip={<Tip id="addRewardToolTip">{this.getRewardText()}</Tip>}>
        <IconWithNumber icon={IconTypes.reward} active={rewardActive} onClick={this.handleClick} />
      </Tooltip>
    )
  }
}

export default injectIntl(AddRewardIcon)
